import React from 'react';
import { motion } from 'framer-motion';
import './Company.css';
import bikeImage from '../assets/bike.jpg';

const Company = () => {
  return (
    <motion.div
      className="company-page"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      <div className="container">
        <motion.div
          className="company-header"
          initial={{ y: -50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.8 }}
        >
          <h1>Solutionspath Technology</h1>
          <p>Innovative Tech Solutions for Tomorrow</p>
        </motion.div>

        <motion.div
          className="company-content"
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.4, duration: 0.8 }}
        >
          <div className="company-image">
            <img src={bikeImage} alt="Solutionspath Technology" />
          </div>
          <div className="company-details">
            <h2>About Our Company</h2>
            <p>
              Solutionspath Technology is a forward-thinking tech company founded and led by Suraj Kumar sah.
              We specialize in delivering cutting-edge software solutions, providing expert technical consulting,
              and driving digital transformation for businesses of all sizes.
            </p>
            <h3>Our Mission</h3>
            <p>
              To bridge the gap between innovative technology and practical business solutions,
              helping companies thrive in the digital age through tailored software development
              and strategic technical guidance.
            </p>
            <h3>Our Services</h3>
            <ul>
              <li>Custom Software Development</li>
              <li>Mobile App Development</li>
              <li>Web Application Development</li>
              <li>Technical Consulting</li>
              <li>Digital Transformation</li>
              <li>IT Infrastructure Solutions</li>
            </ul>
            <a
              href="https://www.solutionspathtechnology.com.np"
              target="_blank"
              rel="noopener noreferrer"
              className="company-website-btn"
            >
              Visit Our Website
            </a>
          </div>
        </motion.div>

        <motion.div
          className="company-values"
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.6, duration: 0.8 }}
        >
          <h2>Our Values</h2>
          <div className="values-grid">
            <div className="value-item">
              <h3>Innovation</h3>
              <p>Constantly pushing boundaries with cutting-edge solutions</p>
            </div>
            <div className="value-item">
              <h3>Excellence</h3>
              <p>Delivering high-quality work that exceeds expectations</p>
            </div>
            <div className="value-item">
              <h3>Collaboration</h3>
              <p>Working closely with clients to achieve shared success</p>
            </div>
            <div className="value-item">
              <h3>Integrity</h3>
              <p>Maintaining honesty and transparency in all our dealings</p>
            </div>
          </div>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default Company;